import { connect } from 'react-redux'
import { withProps, compose, lifecycle, withHandlers } from 'recompose'
import withType from 'components/common/hoc/withType'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import { googleAnalyticProductImpressions, googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import { getCurrentStore, getActiveVehicle, getHasActiveVehicleStatus } from 'selectors'
import { handleStoreSearch, handleTiresSearch } from './actions'
import { processProductData, getGTMData } from './helpers'
import { getBrandName } from '../../selectors'
import BOTCommonBrandTireResultList from './components/BOTCommonBrandTireResultList'
import { navigateToPromo } from '../../../PromotionResultList/PromotionsList/actions'
import { processPromotionLink } from '../../../PromotionResultList/PromotionsList/helpers'


const withPromotionClickHandler = withHandlers({
  handlePromotionClick: ({ googleAnalyticPromotionClicks, navigateToPromo, regionName }) => ({ item, index }) => {
    const { promotionLinkUrl } = item

    navigateToPromo(processPromotionLink({ promotionLinkUrl, regionName }))
    googleAnalyticPromotionClicks({ item, index })
  }
})

const mapStateToProps = state => {
  const { phoneNumbers: [storePhoneNumber] = []} = getCurrentStore(state) || {}
  const { vehicleName } = getActiveVehicle(state)

  return {
    storePhoneNumber,
    brandName: getBrandName(state),
    hasActiveVehicle: getHasActiveVehicleStatus(state),
    activeVehicle: vehicleName,
    hasStore: getCurrentStore(state)
  }
}

const withAnalytics = lifecycle({
  componentDidUpdate(prevProps) {
    const { records, brandName, googleAnalyticProductImpressions } = this.props

    if (records.length && (brandName !== prevProps.brandName || prevProps.records !== records)) {
      googleAnalyticProductImpressions({ data: getGTMData({ records, brandName }) })
    }
  },

  componentDidMount() {
    const { records = [], brandName, googleAnalyticProductImpressions } = this.props

    // it's possible that brandName is not set at this point since it happens when BrandDetail component mounted
    if (brandName && records.length) {
      googleAnalyticProductImpressions({ data: getGTMData({ records, brandName }) })
    }
  }
})

export default compose(
  withType({ type: 'BOTCommonBrandTireResultList' }),
  connect(mapStateToProps, {
    handleStoreSearch,
    handleTiresSearch,
    googleAnalyticProductImpressions,
    googleAnalyticPromotionClicks,
    navigateToPromo
  }),
  withShowConfirmTireSizeModalPreconfigured,
  withPromotionClickHandler,
  withProps(({ records, handleTiresSearch, onClick, PromotionResultList }) =>
    ({
      products: processProductData(records),
      handleTiresSearch: onClick || handleTiresSearch,
      promotions: PromotionResultList || []
    })),
  withSetBazaarVoiceInlineRatings,
  withAnalytics
)(BOTCommonBrandTireResultList)
